import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import type { TenantOnboardingDTO, TenantOnboardingStepPatch } from '@today/types'
import { tenantOnboardingService } from '@/services/tenant-onboarding.service'

const key = (slug: string) => ['tenant-onboarding', slug] as const

/** The tenant's onboarding progress (TO-190 REQ-002); disabled until `enabled` and a slug are both set. */
export function useTenantOnboarding(slug: string | null, enabled = true) {
	return useQuery<TenantOnboardingDTO>({
		queryKey: key(slug ?? ''),
		queryFn: () => tenantOnboardingService.get(slug as string),
		enabled: enabled && Boolean(slug),
	})
}

/** Sets one step's status (TO-190 REQ-003); the response replaces the cached progress. */
export function useSetOnboardingStep(slug: string) {
	const client = useQueryClient()
	return useMutation<TenantOnboardingDTO, unknown, TenantOnboardingStepPatch>({
		mutationFn: (body) => tenantOnboardingService.setStep(slug, body),
		onSuccess: (onboarding) => client.setQueryData(key(slug), onboarding),
	})
}
